import { render, staticRenderFns } from "./newAddDoorModel.vue?vue&type=template&id=3db0c86e&scoped=true&"
import script from "./newAddDoorModel.vue?vue&type=script&lang=js&"
export * from "./newAddDoorModel.vue?vue&type=script&lang=js&"
import style0 from "./newAddDoorModel.vue?vue&type=style&index=0&lang=less&"
import style1 from "./newAddDoorModel.vue?vue&type=style&index=1&id=3db0c86e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0c86e",
  null
  
)

export default component.exports